export const departure = {
    departure_form: {
        PDBShipRef:'',
        VesselName:'',
        PortType:'',
        PortName:'',
        DestinationPortName:'',
        ATDDate:'',
        ATDTime:'',
        ETADate:'',
        ETATime:'',
        DistanceToGo:'',
        ROBMFO:'',
        ROBMGO:'',
        MFOReceived:'',
        MGOReceived:'',
        Product1:'',
        P1DP1:'',
        P1DP1Density:'',
        P1DP1BLQuantityMT:'',
        P1DP1BLQuantityKL15:'',
        P1DP1BLQuantityKL30:'',
        P1DP1BLQuantityBBLS:'',
        P1DP1VLQuantity:'',
        P1DP1Difference:'',
        P1DP1Percentage:'',
        P1DP2:'',
        P1DP2Density:'',
        P1DP2BLQuantityMT:'',
        P1DP2BLQuantityKL15:'',
        P1DP2BLQuantityKL30:'',
        P1DP2BLQuantityBBLS:'',
        P1DP2VLQuantity:'',
        P1DP2Difference:'',
        P1DP2Percentage:'',
        P1DP3:'',
        P1DP3Density:'',
        P1DP3BLQuantityMT:'',
        P1DP3BLQuantityKL15:'',
        P1DP3BLQuantityKL30:'',
        P1DP3BLQuantityBBLS:'',
        P1DP3VLQuantity:'',
        P1DP3Difference:'',
        P1DP3Percentage:'',
        Product2:'',
        P2DP1:'',
        P2DP1Density:'',
        P2DP1BLQuantityMT:'',
        P2DP1BLQuantityKL15:'',
        P2DP1BLQuantityKL30:'',
        P2DP1BLQuantityBBLS:'',
        P2DP1VLQuantity:'',
        P2DP1Difference:'',
        P2DP1Percentage:'',
        P2DP2:'',
        P2DP2Density:'',
        P2DP2BLQuantityMT:'',
        P2DP2BLQuantityKL15:'',
        P2DP2BLQuantityKL30:'',
        P2DP2BLQuantityBBLS:'',
        P2DP2VLQuantity:'',
        P2DP2Difference:'',
        P2DP2Percentage:'',
        P2DP3:'',
        P2DP3Density:'',
        P2DP3BLQuantityMT:'',
        P2DP3BLQuantityKL15:'',
        P2DP3BLQuantityKL30:'',
        P2DP3BLQuantityBBLS:'',
        P2DP3VLQuantity:'',
        P2DP3Difference:'',
        P2DP3Percentage:'',
        Product3:'',
        P3DP1:'',
        P3DP1Density:'',
        P3DP1BLQuantityMT:'',
        P3DP1BLQuantityKL15:'',
        P3DP1BLQuantityKL30:'',
        P3DP1BLQuantityBBLS:'',
        P3DP1VLQuantity:'',
        P3DP1Difference:'',
        P3DP1Percentage:'',
        P3DP2:'',
        P3DP2Density:'',
        P3DP2BLQuantityMT:'',
        P3DP2BLQuantityKL15:'',
        P3DP2BLQuantityKL30:'',
        P3DP2BLQuantityBBLS:'',
        P3DP2VLQuantity:'',
        P3DP2Difference:'',
        P3DP2Percentage:'',
        P3DP3:'',
        P3DP3Density:'',
        P3DP3BLQuantityMT:'',
        P3DP3BLQuantityKL15:'',
        P3DP3BLQuantityKL30:'',
        P3DP3BLQuantityBBLS:'',
        P3DP3VLQuantity:'',
        P3DP3Difference:'',
        P3DP3Percentage:'',
        RCOBP1:'',
        RCOBP1DP1:'',
        RCOBP1DP1Volume:'',
        RCOBP1DP2:'',
        RCOBP1DP2Volume:'',
        RCOBP1DP3:'',
        RCOBP1DP3Volume:'',
        RCOBP2:'',
        RCOBP2DP1:'',
        RCOBP2DP1Volume:'',
        RCOBP2DP2:'',
        RCOBP2DP2Volume:'',
        RCOBP2DP3:'',
        RCOBP2DP3Volume:'',
        RCOBP3:'',
        RCOBP3DP1:'',
        RCOBP3DP1Volume:'',
        RCOBP3DP2:'',
        RCOBP3DP2Volume:'',
        RCOBP3DP3:'',
        RCOBP3DP3Volume:'',
        CreatedTimestamp:'',
        ModifiedTimestamp:'',
      
        ReportFilename: "Departure",
        DateCreated:'',
        DateModify: "",
        ModifyBy: "",
        ReportStatus: "In Progress",

    },
    read_data: {},
    tabs_index: 0,
    tabsRcob_index: 0,
    product_data: {
        product1: '',
        product2: '',
        product3: ''
    },
    product_dropdown:[],
    read_product_data: {},
    is_form_loading: false,
    is_submit_loading: false,
    shipment_data:null,
    tabs_data:[]
}


// WEBPACK FOOTER //
// ./src/reducers/departure/departure.state.js